export enum GameStatusEnum {
  IDLE = "IDLE",
  STARTED = "STARTED",
  PAUSED = "PAUSED",
  COMPLETED_WAVE = "COMPLETED_WAVE",
  FAIL_GAME_OVER = "FAIL_GAME_OVER",
  SUCCESS_GAME_OVER = "SUCCESS_GAME_OVER",
}
